import { AxiosPromise } from 'axios';
import { Args, AxiosConfig, BaseService } from './BaseService';
import { resources } from '../resources';
import { DashboardTileDto } from '../models/dashboard/DashboardTileDto';
import { CreateDashboardTileRequest } from '../models/dashboard/CreateDashboardTileRequest';
import { UpdateDashboardTileRequest } from '../models/dashboard/UpdateDashboardTileRequest';
import { DashboardPage } from '../models/enums/DashboardPage';

export class DashboardTileService extends BaseService {
  // ---- personal tiles --------------------------------------------------

  public listTiles(page: DashboardPage, args?: Args, options?: AxiosConfig): AxiosPromise<DashboardTileDto[]> {
    return this.get<DashboardTileDto[]>(resources.listTiles, { page, ...args }, options);
  }

  public createTile(body: CreateDashboardTileRequest, args?: Args, options?: AxiosConfig): AxiosPromise<{ id: string }> {
    return this.post<{ id: string }>(resources.createTile, body, args, options);
  }

  public updateTile(tileId: string, body: UpdateDashboardTileRequest, args?: Args, options?: AxiosConfig): AxiosPromise<void> {
    return this.put<void>(resources.updateTile, body, { tileId, ...args }, options);
  }

  public deleteTile(tileId: string, args?: Args, options?: AxiosConfig): Promise<boolean> {
    return this.delete<void>(resources.deleteTile, { tileId, ...args }, options).then((r) => r.status !== 0);
  }

  public reorderTiles(orderedIds: string[], args?: Args, options?: AxiosConfig): AxiosPromise<void> {
    return this.put<void>(resources.reorderTiles, { tileIds: orderedIds }, args, options);
  }

  // ---- company defaults ------------------------------------------------

  public listCompanyDefaults(companyId: string, page: DashboardPage, args?: Args, options?: AxiosConfig): AxiosPromise<DashboardTileDto[]> {
    return this.get<DashboardTileDto[]>(resources.listCompanyDefaults, { companyId, page, ...args }, options);
  }

  public createCompanyDefault(companyId: string, body: CreateDashboardTileRequest, args?: Args, options?: AxiosConfig): AxiosPromise<{ id: string }> {
    return this.post<{ id: string }>(resources.createCompanyDefault, body, { companyId, ...args }, options);
  }

  public updateCompanyDefault(companyId: string, tileId: string, body: UpdateDashboardTileRequest, args?: Args, options?: AxiosConfig): AxiosPromise<void> {
    return this.put<void>(resources.updateCompanyDefault, body, { companyId, tileId, ...args }, options);
  }

  public deleteCompanyDefault(companyId: string, tileId: string, args?: Args, options?: AxiosConfig): Promise<boolean> {
    return this.delete<void>(resources.deleteCompanyDefault, { companyId, tileId, ...args }, options).then((r) => r.status !== 0);
  }

  // ---- global defaults -------------------------------------------------

  public listGlobalDefaults(page: DashboardPage, args?: Args, options?: AxiosConfig): AxiosPromise<DashboardTileDto[]> {
    return this.get<DashboardTileDto[]>(resources.listGlobalDefaults, { page, ...args }, options);
  }

  public createGlobalDefault(body: CreateDashboardTileRequest, args?: Args, options?: AxiosConfig): AxiosPromise<{ id: string }> {
    return this.post<{ id: string }>(resources.createGlobalDefault, body, args, options);
  }

  public updateGlobalDefault(tileId: string, body: UpdateDashboardTileRequest, args?: Args, options?: AxiosConfig): AxiosPromise<void> {
    return this.put<void>(resources.updateGlobalDefault, body, { tileId, ...args }, options);
  }

  public deleteGlobalDefault(tileId: string, args?: Args, options?: AxiosConfig): Promise<boolean> {
    return this.delete<void>(resources.deleteGlobalDefault, { tileId, ...args }, options).then((r) => r.status !== 0);
  }
}
